
import { WordSelectionStrategy } from './WordSelectionStrategy';
import { getYearlySequences } from '../wordLibrary';
import { getDayOfYear, normalizeDate } from '../dateUtils';

export class DailyWordStrategy implements WordSelectionStrategy {
  getStrategyId(): string {
    return 'daily';
  }
  
  getWordSequence(date: Date): string[] {
    try {
      // Always work with normalized dates to ensure consistency
      const normalizedDate = normalizeDate(date);
      
      // Get sequences for the year
      const year = normalizedDate.getFullYear();
      const sequences = getYearlySequences(year);
      
      if (!sequences || !Array.isArray(sequences)) {
        console.error('Failed to get word sequences for year:', year);
        return ['cat', 'cats', 'caste', 'castle']; // Fallback default sequence
      }
      
      // Calculate day of year for deterministic selection
      const dayOfYear = getDayOfYear(normalizedDate);
      const sequenceIndex = dayOfYear % sequences.length;
      const selectedSequence = sequences[sequenceIndex];
      
      console.log('[DailyWordStrategy] Selected word sequence:', {
        date: normalizedDate.toISOString(),
        year,
        dayOfYear,
        sequenceIndex,
        sequence: selectedSequence,
        timestamp: new Date().toISOString(),
        source: 'DailyWordStrategy.getWordSequence'
      });
      
      return selectedSequence;
      
    } catch (error) {
      console.error('Error in daily word selection:', error);
      return ['cat', 'cats', 'caste', 'castle']; // Fallback sequence
    }
  }
}
